import { render, staticRenderFns } from "./excelOmzet1.vue?vue&type=template&id=6bc5e1f4"
import script from "./excelOmzet1.vue?vue&type=script&lang=js"
export * from "./excelOmzet1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports